var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallerDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 33,
    viewBox: "0 0 19 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.77121 1.28495C0.30999 1.7311 0.0508918 2.33613 0.0508918 2.96699C0.0508917 3.59784 0.30999 4.20287 0.77121 4.64902L12.9493 16.4257L0.771209 28.2023C0.32306 28.651 0.0750853 29.252 0.080691 29.8758C0.0862967 30.4996 0.345034 31.0963 0.801177 31.5374C1.25732 31.9785 1.87437 32.2287 2.51943 32.2341C3.16449 32.2395 3.78595 31.9997 4.24995 31.5664L18.1674 18.1077C18.6286 17.6615 18.8877 17.0565 18.8877 16.4257C18.8877 15.7948 18.6286 15.1898 18.1674 14.7436L4.24995 1.28495C3.78859 0.838936 3.16294 0.588378 2.51058 0.588378C1.85822 0.588378 1.23257 0.838936 0.77121 1.28495Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallerDownarrow);
export default __webpack_public_path__ + "static/media/smaller-downarrow.6f369543e081de8bfd2cec99239b063c.svg";
export { ForwardRef as ReactComponent };